import {Injectable} from '@angular/core';
import {KluhManagerValidator} from '../../../../../validators/kluh-manager-validator';
import {BaseSearchDao} from '../../../../../base-search-dao';
import {Observable} from 'rxjs/internal/Observable';
import {VpnMonitoringConfiguration} from '../../../../../models-monitoring';
import {ServerType} from '../../../../../models';
import {R2CloudHttpMonitoringService} from '../../../../../r2-cloud-http-monitoring.service';

@Injectable({
    providedIn: 'root'
})
export class VpnMonitoringConfigurationDaoService extends BaseSearchDao<VpnMonitoringConfiguration> {
    constructor(http: R2CloudHttpMonitoringService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'vpn-monitoring-configuration');
    }

    findAllByServerIdAndServerType(serverId: number, serverType: ServerType): Observable<VpnMonitoringConfiguration[]> {
        return this.http.get<VpnMonitoringConfiguration[]>(this.url + '/find-all-by-server-id-and-server-type/' + serverType + '/' + serverId);
    }
}
